import React from 'react';
import { Box, Grid, Typography, Container } from '@mui/material';
import DaynamicReportCard from "../../CustomComponent/DaynamicReportCard.js";
import { ReactComponent as ReportsIcon } from "../../images/mainheadingicon/Reportsicon.svg";
import PageHeader from '../PageHeader.js';
import { Reportsdata } from './AllReportsListData.js';



function AllRepors() {
 
  const Heading = [
    {
      id: 1,
      pageicon: <ReportsIcon />,
      mainheading: "Reports",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      // addbtntext: "Back",
      // addbtnicon: <BackIcon />,
      // addbtnstyle: "transparentbtn",
      // path: "/admin/exam",
    },]

  return (
    <Container style={{  paddingBottom: "30px" }} maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <PageHeader Heading={Heading} />
      </Box>


      {/* Grid Layout */}
      <Grid style={{ height: "72vh", paddingBottom: "30px", overflow: "auto", scrollbarWidth: "none" }} container spacing={3}>
        {Reportsdata.map((data, index) => (
          <Grid style={{ display: 'flex' }} item xs={12} sm={6} md={4} key={index}>
            <DaynamicReportCard data={data} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default AllRepors;